/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAttachmentsEnrollmentDocuments200,
  GetApiV1PersonIdAttachmentsEnrollmentDocuments401,
  GetApiV1PersonIdAttachmentsEnrollmentDocuments404,
  GetApiV1PersonIdAttachmentsEnrollmentDocuments500,
  GetApiV1PersonIdAttachmentsEnrollmentDocumentsPathParams,
  GetApiV1PersonIdAttachmentsEnrollmentDocumentsQueryParams,
  GetApiV1PersonIdAttachmentsEnrollmentDocumentsQueryResponse,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsEnrollmentDocuments.ts";
import { enrollmentDocumentDropDownItemViewModelSchema } from "../enrollmentDocumentDropDownItemViewModelSchema.ts";

export const getApiV1PersonIdAttachmentsEnrollmentDocumentsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PersonIdAttachmentsEnrollmentDocumentsPathParams>;

export const getApiV1PersonIdAttachmentsEnrollmentDocumentsQueryParamsSchema = z
  .object({
    classStudentId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1PersonIdAttachmentsEnrollmentDocumentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAttachmentsEnrollmentDocuments200Schema = z.array(
  z.lazy(() => enrollmentDocumentDropDownItemViewModelSchema),
) as unknown as ToZod<GetApiV1PersonIdAttachmentsEnrollmentDocuments200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAttachmentsEnrollmentDocuments401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsEnrollmentDocuments401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdAttachmentsEnrollmentDocuments404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsEnrollmentDocuments404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAttachmentsEnrollmentDocuments500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsEnrollmentDocuments500>;

export const getApiV1PersonIdAttachmentsEnrollmentDocumentsQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonIdAttachmentsEnrollmentDocuments200Schema,
  ) as unknown as ToZod<GetApiV1PersonIdAttachmentsEnrollmentDocumentsQueryResponse>;
